import React, { Suspense } from "react";
import { FlexboxGrid, Header } from "rsuite";

import LoaderComponent from "./components/loader/LoaderComponent";
import FooterComponent from "./components/footer/FooterComponent";
import ErrorBoundary from "./components/error/ErrorBoundary";
import Brand from "./components/logo/Brand";

import { useGlobalPersistentStore } from "./store";

import "./App.css";

const DashboardContainer = React.lazy(() =>
  import("./containers/dashboard/DashboardContainer")
);
const AuthorizationContainer = React.lazy(() =>
  import("./containers/authorization/AuthorizationContainer")
);
const LoginContainer = React.lazy(() =>
  import("./containers/authorization/LoginContainer")
);

function App() {
  const { loggedInUserDetails = {}, brokerLoginDetails = {} } =
    useGlobalPersistentStore();

  const renderMainContent = () => {
    if (!loggedInUserDetails?.username) {
      return <LoginContainer />;
    }

    if (!brokerLoginDetails?.clientCode) {
      return <AuthorizationContainer />;
    }

    return <DashboardContainer />;
  };

  return (
    <div className="main-app-container">
      <ErrorBoundary>
        <Suspense fallback={<LoaderComponent />}>
          <Header className="header">
            <FlexboxGrid justify="left" align="middle">
              <Brand expand={true} />
            </FlexboxGrid>
          </Header>
          {renderMainContent()}
          <FooterComponent />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default App;
